module.exports = __webpack_public_path__ + "img/hengshui-2bddcf.png";